import axios from 'axios';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    async translate(vuexContext, { text, lang }) {
        const res = await axios.$get('/v1/contents/translate', { params: { text, lang } });

        return res.data?.text;
    }
};
